import { render, staticRenderFns } from "./memberOrderHistoryComponent.vue?vue&type=template&id=39052ee2&"
import script from "./memberOrderHistoryComponent.vue?vue&type=script&lang=ts&"
export * from "./memberOrderHistoryComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports